import React from 'react';
import { FormattedMessage } from 'react-intl';

function ConfirmModal(props) {
  const { 
    actionType,
    selectedItem,
    checkedItems,
    handleDelete,
    closeModal,
    dataType,
  } = props;

  const titleString = capitalizeFirstLetter(dataType);

  // Function to capitalize the first letter of a string
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  /**
   * Get the confirmation message for the delete operation
   * @param {*} checkedItems - array of items to be deleted
   * @param {*} dataType - type of items to be deleted
   * @returns 
   */
  const getDeleteConfirmationMessage = (checkedItems, dataType) => {
    if (dataType === "Alert") {
      return <FormattedMessage id="CONFIRM_ALERT_CLEAR" />;
    } else if (dataType === "account") {
      return (
        <FormattedMessage
          id="CONFIRM_ACCOUNT_DELETE"
          values={{ dataType: <b>{dataType}</b> }}
        />
      );
    }

    const itemCount = actionType === 'single' ? 1 : checkedItems.length;
    let itemLabel;

    if (dataType === "CMS") {
      // Handle irregular pluralization for "CMS"
      itemLabel = itemCount === 1 ? dataType : `CMSes`;
    } else {
      itemLabel = itemCount === 1 ? dataType : `${dataType}s`;
    }

    return (
      <FormattedMessage
        id="CONFIRM_MESSAGE"
        values={{ counts: itemCount, dataType: itemLabel }}
      />
    );
  };

  return (
    <div className="modal fade" id="confirmModal" tabIndex="-1" aria-labelledby="confirmModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <button type="button" id="closeConfirmModalBtn" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body text-center">
            <div className="modal-body-title">
              {getDeleteConfirmationMessage(checkedItems, dataType)}
            </div>
            <div className="modal-body-subtitle">
              <FormattedMessage id="THIS_ACTION_CANNOT_BE_UNDONE" />
            </div>
          </div>
          <div className="modal-footer mt-3 justify-content-between">
            <button className="btn back-btn" id="backBtn" type="button" onClick={() => closeModal('confirmModal')}><FormattedMessage id="CANCEL" /></button>
            <button className="btn save-btn ms-2" id="confirmBtn" type="button" onClick={handleDelete}><FormattedMessage id="CONFIRM_BTN" /></button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;
